import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.textContent.trim())

    const original = this.buttonTarget.innerHTML
    this.buttonTarget.innerHTML = `<i class="fa-solid fa-check"></i> Copied`
    setTimeout(() => { this.buttonTarget.innerHTML = original }, 2000)
  }
}
